import { Body, Sheet, VStack } from '@hover/blueprint';
import { iCamera, iImage } from '@hover/icons';
import React from 'react';

import { useHomeownerAppContext } from 'src/modules/homeownerApp/hooks/useHomeownerAppContext';
import { PhotoUploadInput } from 'src/shared/components/Upload/PhotoUploadInput';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

const UploadPhotoSheet = () => {
  const { setImageFileToUpload, setCurrentMenu } = useHomeownerAppContext();
  const t = useTranslate([
    TranslationNamespace.HOMEOWNER_APP,
    TranslationNamespace.COMMON,
  ]);

  const onUploadPhotoChange: (
    photoUploadFile: File,
  ) => void = photoUploadFile => {
    setImageFileToUpload(photoUploadFile);
    setCurrentMenu();
  };

  return (
    <Sheet.Contents header={t('uploadPhotoSheet.header')}>
      <VStack align="stretch" py={300} spacing={300}>
        <Body color="neutral.500" size={300}>
          {t('uploadPhotoSheet.subHeader')}
        </Body>

        <PhotoUploadInput
          icon={iCamera}
          label={t('uploadPhotoSheet.takePhotoAction')}
          onFileChange={onUploadPhotoChange}
        />
        <PhotoUploadInput
          icon={iImage}
          label={t('uploadPhotoSheet.photoLibraryAction')}
          onFileChange={onUploadPhotoChange}
        />
      </VStack>
    </Sheet.Contents>
  );
};

export { UploadPhotoSheet };
